module.exports = __webpack_public_path__ + "robotomono-regular-webfont-0ba95b3b2370e6bf1dcdb20aa3a54ff2.ttf";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/fonts/roboto-mono/robotomono-regular-webfont.ttf
// module id = 878
// module chunks = 88